import { render } from "./MedicationFormDialog.vue?vue&type=template&id=fcbac396&scoped=true"
import script from "./MedicationFormDialog.vue?vue&type=script&lang=js"
export * from "./MedicationFormDialog.vue?vue&type=script&lang=js"

import "./MedicationFormDialog.vue?vue&type=style&index=0&id=fcbac396&lang=css"
import "./MedicationFormDialog.vue?vue&type=style&index=1&id=fcbac396&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcbac396"]])

export default __exports__